import React from 'react';
import PushOptIn from '../components/PushOptIn';
import SEO from '../components/SEO';

export default function NotificationsSettings() {
  return (
    <div className="page" style={{ maxWidth: 720, margin: '0 auto', padding: '2rem 1rem' }}>
      <SEO title="Notification settings" />
      <h1>Notification settings</h1>
      <p style={{ color: 'var(--text-light)' }}>
        Get instant push notifications when products you care about restock, when your orders ship, and when new sealed product drops.
      </p>
      <div style={{ marginTop: 24, padding: 24, background: 'var(--bg-panel)', border: '1px solid var(--border-color)', borderRadius: 12 }}>
        <PushOptIn />
      </div>
    </div>
  );
}
